import React from "react";

import { SimulationList } from "./SimulationList";
import { PastFutureDataSetting } from "./PastFutureDataSetting";

export const ModalWindow = (props: any) => {
  const {
    setIsSettingWindowOpen,
    currentReferenceTime,
    dataListState,
    maxRainfall,
    maxFutureRainfall,
    modalType,
    setDataListState,
    setModalType,
    getSimulationsList,
    getSimulationData,
    getPastFutureInputData,
    simulationList,
    plyFileURLList,
    setimeSlot,
    setIsLoading,
    postCancelSimulation,
    getSimulationPlyData,
    postRunSimulation,
    // savedData,
    // setSavedData,
    // referenceTime,
    getPastData,
    pastWaterLevel,
    pastRainfall,
    pastFutureInputData,
    setPastWaterLevel,
    setPastRainfall,
    setPastFutureInputData,
    PastRainDataList,
    postPastRainDataInsert,
    setReferenceDateTime,
    user,
  } = props;
  const pastDataArray = [...pastWaterLevel, ...pastRainfall];
  const isAllDataInputted = () => {
    let isAllPastDataInputted = pastDataArray.every(
      (data: { input_data?: number }) =>
        typeof data.input_data === "number" && !isNaN(data.input_data)
    );

    // デバッグ用のログ出力
    // dataListState.map((data: { input_rain_amount?: number }) => {
    //     console.log("Checking data:", data);
    //     console.log("Result:", typeof data.input_rain_amount === 'number' && !isNaN(data.input_rain_amount));
    //     return typeof data.input_rain_amount === 'number' && !isNaN(data.input_rain_amount);
    // });

    let isAllFutureDataInputted = dataListState.every(
      (data: { input_rain_amount?: number }) =>
        typeof data.input_rain_amount === "number" &&
        !isNaN(data.input_rain_amount)
    );
    let isAllDataInputted = isAllPastDataInputted && isAllFutureDataInputted;

    // console.log("★isAllPastDataInputted =", isAllPastDataInputted);
    // console.log("★isAllFutureDataInputted =", isAllFutureDataInputted);
    // console.log("★isAllDataInputted =", isAllDataInputted);

    return isAllDataInputted;
  };
  return (
    <>
      {/** setting window */}
      <div
        className="absolute left-0 top-0 w-[100vw] h-full z-2 bg-gray-500 opacity-80"
        onClick={() => setIsSettingWindowOpen(false)}
      ></div>
      <div
        className={`absolute left-1/2 top-1/2 z-3 -translate-x-1/2 -translate-y-1/2 
          text-white bg-white py-4 px-8 overflow-scroll
          ${
            modalType === "pastFutureData"
              ? "max-h-[1000px] w-[1600px]"
              : modalType === "pastFutureDataReference"
              ? "max-h-[1000px] w-[1600px]"
              : "max-h-[500px] min-w-[1200px]"
          }
        `}
      >
        <div className="flex items-end mb-4">
          <img src="./img/spanner_color.png" className="w-[30px]" />
          <p className="text-settingWindowMain font-bold text-[20px]">
            {modalType === "pastFutureData" && "シミュレーション条件設定"}
            {modalType === "pastFutureDataReference" &&
              "シミュレーション条件確認"}
            {modalType === "simulation" && "シミュレーション一覧"}
          </p>
          {modalType === "railfall" && (
            <p className="text-gray-400 text-[0.5vw] ml-4">
              {`※時間と降雨量を設定してください　(調整後現在時刻：${currentReferenceTime})`}
            </p>
          )}
        </div>
        {modalType === "pastFutureData" && (
          // <div className="flex items-center justify-between">
          <div className="flex justify-end items-center">
            <button
              type="button"
              disabled={
                !(
                  user["https://hirono-flood-sim/roles"][0] === "exec" &&
                  isAllDataInputted()
                )
              }
              onClick={() => {
                (async () => {
                  await postRunSimulation(dataListState, pastDataArray);
                  await getSimulationsList();
                  setModalType("simulation");
                })();
              }}
              className={`mt-[10px] flex items-center justify-around text-planeText h-[60px] focus:outline-none text-white
        focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-planeText px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900
        ${
          user["https://hirono-flood-sim/roles"][0] === "exec" &&
          isAllDataInputted()
            ? "bg-settingWindowMain hover:bg-ArithmerBlue"
            : "bg-gray-300 hover:bg-gray-300 cursor-not-allowed"
        }
        `}
            >
              <div className="flex items-center">
                <p className="">シミュレーション実行</p>
              </div>
              {/* <img src="./img/arrow_02.png" className="w-[20px]" /> */}
            </button>
          </div>
        )}
        {modalType === "pastFutureData" && (
          <PastFutureDataSetting
            setModalType={setModalType}
            modalMode="edit"
            dataListState={dataListState}
            setDataListState={setDataListState}
            // savedData={savedData}
            // referenceTime={referenceTime}
            pastWaterLevel={pastWaterLevel}
            pastRainfall={pastRainfall}
            pastFutureInputData={pastFutureInputData}
            setPastWaterLevel={setPastWaterLevel}
            setPastRainfall={setPastRainfall}
            setPastFutureInputData={setPastFutureInputData}
            getPastData={getPastData}
            PastRainDataList={PastRainDataList}
            postPastRainDataInsert={postPastRainDataInsert}
            // setSavedData={setSavedData}
            postRunSimulation={postRunSimulation}
            getSimulationsList={getSimulationsList}
            maxRainfall={maxRainfall}
            maxFutureRainfall={maxFutureRainfall}
            user={user}
          />
        )}
        {modalType === "pastFutureDataReference" && (
          <PastFutureDataSetting
            setModalType={setModalType}
            modalMode="reference"
            dataListState={dataListState}
            setDataListState={setDataListState}
            // savedData={savedData}
            // referenceTime={referenceTime}
            pastWaterLevel={pastWaterLevel}
            pastRainfall={pastRainfall}
            pastFutureInputData={pastFutureInputData}
            setPastWaterLevel={setPastWaterLevel}
            setPastRainfall={setPastRainfall}
            setPastFutureInputData={setPastFutureInputData}
            getPastData={getPastData}
            PastRainDataList={PastRainDataList}
            postPastRainDataInsert={postPastRainDataInsert}
            // setSavedData={setSavedData}
            postRunSimulation={postRunSimulation}
            getSimulationsList={getSimulationsList}
            maxRainfall={maxRainfall}
            maxFutureRainfall={maxFutureRainfall}
            user={user}
          />
        )}
        {modalType === "simulation" && (
          <SimulationList
            setIsSettingWindowOpen={setIsSettingWindowOpen}
            setDataListState={setDataListState}
            setModalType={setModalType}
            getSimulationsList={getSimulationsList}
            getSimulationData={getSimulationData}
            simulationList={simulationList}
            plyFileURLList={plyFileURLList}
            setIsLoading={setIsLoading}
            setimeSlot={setimeSlot}
            postCancelSimulation={postCancelSimulation}
            getSimulationPlyData={getSimulationPlyData}
            setReferenceDateTime={setReferenceDateTime}
            getPastData={getPastData}
            getPastFutureInputData={getPastFutureInputData}
            user={user}
          />
        )}
      </div>
    </>
  );
};
